import React from 'react';
import Horarios from "../../Components/Lista/Horarios";
import styled from "styled-components";

const Text=styled.h1`
margin:0;
justify-self:center;
font-size:24px;`;

const SubText=styled.h3`
text-align:center;
margin:0;
margin-top: 1rem;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}`;

const StatusDesactivada = ({Logo}) =>
{
    return <>
        {Logo}
        <Text>Lista de espera</Text>
        <SubText style={{marginTop:"1.2rem", padding:"0px 30px", fontSize:"22px"}}>En estos momentos contamos con lugar, no es necesario anotarse... los esperamos! 🍻🤙</SubText>
        <Horarios/>
    </>
}

export default StatusDesactivada
